export default "__VITE_ASSET__Cw5dlZha__"